// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__fk4U7","placeholdersHeader":"styles_placeholdersHeader__21wqR","editorStyle":"styles_editorStyle__3drvI","placeholdersBox":"styles_placeholdersBox__3zi4G"};